import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KbcUlsterModalActionsVm } from 'src/app/models/app/kbc-ulster-modal-action';
import * as strings from './kbc-ulster-modal.component.strings';
import { BaseModalComponent } from '../base-modal/base-modal.component';


@Component({
    selector: 'app-kbc-ulster-modal',
    templateUrl: './kbc-ulster-modal.component.html',
    styleUrls: ['./kbc-ulster-modal.component.scss'],
    imports: [BaseModalComponent]
})
export class KbcUlsterModalComponent {
    @Input() inProcessModal: boolean = false;
    modalActions: KbcUlsterModalActionsVm = new KbcUlsterModalActionsVm();
    @Input() set inputs(value: KbcUlsterModalActionsVm) {
        this.modalActions = value;
    }

    public s = strings;
    public waiting: boolean = false;

    constructor(public activeModal: NgbActiveModal) { }

    async onAction() {
        this.waiting = true;

        if (this.modalActions && this.modalActions.customAction) {
            await this.modalActions.customAction();
        }

        this.activeModal.close();
    }
}